import { LitElement, html } from "lit-element"
import Cookies from "../utilities/cookies"
import Types from "../utilities/types"
import BrowsersWhitelist from '../utilities/browser-whitelist'
import ResizeObserver from 'resize-observer-polyfill'

let ForcedRatioElementsResizeObserver = new ResizeObserver(entries => {
	for (let entry of entries) {
		entry.target.HandleElementResize(entry.contentRect)
	}
});

let VisibleInViewportObserver = { observe: () => { }, unobserve: () => { } }

const loadingOffset = 500;

if (window.IntersectionObserver != null) {
	VisibleInViewportObserver = new IntersectionObserver(entries => {
		for (let entry of entries) {
			entry.target.HandleElementVisibleInViewport(entry.contentRect)
		}
	}, { rootMargin: `0px 0px ${loadingOffset}px 0px`, threshold: 0 });
}

window.LitElementsFastSlottedEnabled = false;

export default class LitElementBase extends LitElement {
	/**
	 * @description Getters
	 * @property {String}  DomTag - The tag of the custom element, needs to be overriden on every subclass
	 */
	 static get DomTag() { return '_Override_in_Subclass_'; }

	 GetTranslations() {
		 return null;
		 /*
		 Example return structure:
		 return {
			 "Days":{
				 "it": "Giorni",
				 "en": "Days"
			 },
			 "Hours":{
				 "it": "Ore",
				 "en": "Hours"
			 },
 
		 }
		 */
	 }
 
	 static get properties() {
		 return {
			 lang: { type: String },
			 w2h_ratio: { type: String },
			 observe_visibility: { type: Boolean },
			 notify_status: { type: String },
			 process_slots: { type: String },
 
		 }
	 }
 
	 static get slotted() { return CustomSlottedEnabled; }
	 static set slotted(value) { CustomSlottedEnabled = value; }
 
	 Ln(sTxt, Data) {
		 let sTxtOut = sTxt
		 if ((this.GetTranslations() == null || this.GetTranslations()[sTxt] == null || this.GetTranslations()[sTxt][this.lang] == null) == false)
			 sTxtOut = this.GetTranslations()[sTxt][this.lang];
 
		 if (Data != null) {
			 Object.keys(Data).forEach((str) => {
				 sTxtOut = sTxtOut.split(`{{ ${str} }}`).join(Data[str]);
				 sTxtOut = sTxtOut.split(`{{${str}}}`).join(Data[str]);
			 })
		 }
 
		 return sTxtOut
	 }
 
	 constructor() {
		 super();
 
		 this.DefaultLang = "en";
		 this.AvailableLangs = ["it", "en"];
 
 
		 let userLang = Cookies.Get("Lang") || navigator.language || navigator.userLanguage;
		 userLang = userLang.split("-")[0].toLowerCase();
		 if (this.AvailableLangs.indexOf(userLang) < 0)
			 userLang = this.DefaultLang;
		 this.lang = userLang;
 
		 this.w2h_ratio = "";
		 this.observe_visibility = false;
		 this.IsInViewport = false;
 
		 this.process_slots = true;
	 }
 
	 initialize() {
		 if (window.LitElementsFastSlottedEnabled == true) {
			 this.SlottedCreateRenderRoot = this.createRenderRoot;
			 this.createRenderRoot = () => { return document.createElement("div"); }
		 }
		 super.initialize();
	 }
 
	 connectedCallback() {
		 if (window.LitElementsFastSlottedEnabled == true) {
			 setTimeout(() => {
				 if (Types.ToBool(this.process_slots) == true)
					 this.ParseSlots();
				 if (this.SlottedCreateRenderRoot != null)
					 this.renderRoot = this.SlottedCreateRenderRoot();
				 super.connectedCallback();
			 }, 10);
		 }
		 else {
			 if (Types.ToBool(this.process_slots) == true)
				 this.ParseSlots();
			 super.connectedCallback();
		 }
	 }
 
	 disconnectedCallback() {
		 super.disconnectedCallback();
 
		 ForcedRatioElementsResizeObserver.unobserve(this)
		 VisibleInViewportObserver.unobserve(this);
	 }
 
	 createRenderRoot() {
		 return this;
	 }
 
	 render() {
		 return html``;
	 }
 
	 updated(changedProperties) {
		 super.updated(changedProperties);
 
		 if (changedProperties.has("w2h_ratio")) {
			 if (this.w2h_ratio != "") {
				 ForcedRatioElementsResizeObserver.observe(this);
				 this.HandleElementResize()
			 }
			 else
				 ForcedRatioElementsResizeObserver.unobserve(this);
		 }
		 if (changedProperties.has("observe_visibility")) {
			 if (this.observe_visibility == "true" || this.observe_visibility == true) {
				 VisibleInViewportObserver.observe(this);
			 }
			 else
				 VisibleInViewportObserver.unobserve(this);
		 }
	 }
 
	 ParseSlots() {
		 // Importa gli slot nei parametri
		 let v = this.querySelectorAll('[slot]');
		 if (v == null || v.length == 0)
			 return;
 
		 let AlreadyProcessed = {}
		 v.forEach((el) => {
			 let name = el.getAttribute("slot");
			 if (name == null || name == "" || AlreadyProcessed[name] != null)
				 return;
 
			 this[name] = el.innerHTML;
			 AlreadyProcessed[name] = true;
		 })
	 }
 
	 ToHtml(htmlString) {
		 const template = document.createElement('template');
		 template.innerHTML = htmlString;
		 return document.importNode(template.content, true);
	 }
 
	 /**
	  * Method to emit a custom event
	  * @method
	  * @param {String} EventName - The name of the custom event that will be emitted
	  * @param {Object} oData - The additional data passaed to the custom event
	  */
	 EmitEvent(EventName, oData) {
		 let myEvent = new CustomEvent(EventName, { detail: oData, bubbles: true, composed: true });
		 this.dispatchEvent(myEvent);
	 }
 
	 /**
	  * Method to define a new custom element, it also will be added to the window object (the extending class needs to have the name parameter)
	  * @method
	  * @param {String} route - Wire the custom element to a specific route
	  */
	 static RegisterElement(route) {
		 customElements.define(this.DomTag, this);
		 window[this.name] = this;
		 if (route != null) {
			 if (route == "/")
				 route = "";
			 if (window.SectionRoutes == null)
				 window.SectionRoutes = {}
			 window.SectionRoutes[route] = this.DomTag;
		 }
	 }

	 SetForcedHeight(sHeightPx) {
		 this.style.height = sHeightPx;
		 if (sHeightPx == "auto")
			 this.classList.remove("forced-height")
		 else
			 this.classList.add("forced-height")
	 }
 
	 HandleElementResize(rc) {
		 if (rc == null)
			 rc = this.getBoundingClientRect()
 
		 if (this.w2h_ratio != "") {
			 let ratio = 0
			 switch (this.w2h_ratio) {
				 case "16:9":
					 ratio = 16 / 9;
					 break;
				 case "9:16":
					 ratio = 9 / 16;
					 break;
				 case "16:10":
					 ratio = 16 / 10;
					 break;
				 case "10:16":
					 ratio = 10 / 16;
					 break;
				 case "4:3":
					 ratio = 4 / 3;
					 break;
				 case "1:2":
					 ratio = 1 / 2;
					 break;
				 case "1:1":
					 ratio = 1;
					 break;
				 default:
					 ratio = Types.ToFloat(this.w2h_ratio);
					 break;
			 }
 
			 if (ratio > 0) {
				 let w2h = (rc.width / ratio);
				 this.SetForcedHeight((w2h).toString() + "px");
			 }
		 }
		 else {
			 this.SetForcedHeight("auto");
		 }
	 }
 
	 _GetScrollableContainer() {
		 if (BrowsersWhitelist.IsMobile == true && (this.closest('.scrollable-container') != null || this.closest('.ScrollableContainer') != null))
			 return (this.closest('.scrollable-container') || this.closest('.ScrollableContainer'));
 
		 let parent = this.parentNode
		 while (parent != null && parent != document.body) {
			 if (parent.scrollHeight > parent.clientHeight)
				 return parent;
			 parent = parent.parentNode
		 }
 
		 return null;
	 }
 
	 IntersectsViewport(rc) {
		 if (rc == null)
			 rc = this.getBoundingClientRect();
 
		 let vpH = (window.innerHeight || document.documentElement.clientHeight);
		 let vpW = (window.innerWidth || document.documentElement.clientWidth);
 
		 let cntT = 0
		 let cntL = 0
		 let cntH = vpH
		 let cntW = vpW
		 let sc = this._GetScrollableContainer()
		 if (sc != null) {
			 let rcp = sc.getBoundingClientRect();
			 cntT = rcp.top
			 cntL = rcp.left
			 cntH = cntT + rcp.height
			 cntW = cntL + rcp.width
		 }
 
		 return (
			 (rc.top >= cntT || rc.bottom >= cntT) &&
			 (rc.top <= cntH + loadingOffset || rc.bottom <= cntH) &&
			 (rc.top >= 0 || rc.bottom >= 0) &&
			 (rc.top <= vpH + loadingOffset || rc.bottom <= vpH) &&
			 (rc.left >= cntL || rc.right >= cntL) &&
			 (rc.left <= cntW || rc.right <= cntW) &&
			 (rc.left >= 0 || rc.right >= 0) &&
			 (rc.left <= vpW || rc.right <= vpW)
		 );
	 }
 
	 HandleElementVisibleInViewport(rc) {
		 if (this.IntersectsViewport(rc) == true) {
			 if (this.IsInViewport != true) {
				 this.IsInViewport = true;
				 this.EmitEvent("notify_viewport_enter", { FirstTime: this.AlreadyInViewport != true });
				 this.AlreadyInViewport = true;
			 }
		 }
		 else if (this.IsInViewport === true) {
			 this.EmitEvent("notify_viewport_exit");
			 this.IsInViewport = false;
		 }
	 }
}